import * as React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';

import { TextField, Typography } from '@mui/material';
import { DamsColors } from '../../components/styles/DamsColors';


interface Props{

    placeholder?: string;
    handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    value?:string |number,
    loading?:boolean,
    width?:string | number
    label?:string
}

export default function ControllerTextInput({value,loading,handleChange,placeholder,width,label}:Props) {
  


  return (
    <Box sx={{ minWidth: 120 }}>
      {label &&
           <Typography
           fontFamily={"Inter"}
           fontWeight={400}
           fontSize={12}
           color={"#667085"}
         >
           {label}
         </Typography>}
      <FormControl fullWidth sx={{width}}>
        <TextField
          id="controller-simple-select"
          value={value??''}
          disabled={loading}
          placeholder={placeholder}
          onChange={handleChange}
          sx={styles.input}
        
   
        >

        </TextField>
      </FormControl>
    </Box>
  );
}const styles = {

  input: {
    padding:0,
    borderRadius: "8px",
    borderColor: `${DamsColors.Border.PageInput} !important`,
    "& .MuiInputBase-input": {
        height: 25,      
        padding: "6px 10px", 


      },
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        "& fieldset": {
          borderColor: `${DamsColors.Border.PageInput} !important`,
        },
        "&:hover fieldset": {
          borderColor: `${DamsColors.Border.PageInput} !important`,
        },
        "&.Mui-focused fieldset": {
          borderColor: `${DamsColors.Border.PageInput} !important`,
        },
        "&.Mui-disabled fieldset": {
          borderColor: `${DamsColors.Border.PageInput} !important`,
        },
      },
  },
}; 